import { useEffect, useState } from "react";
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import dynamic from "next/dynamic";
import { styles } from "../../components/installementStyle";
import { useRouter } from "next/router";
import { useI18n } from "@/i18n/I18nProvider";
import Link from "next/link";
import Image from "next/legacy/image";
const PageHead = dynamic(() => import("@/components/PageHead"));


export default function CustomerServicesPage() {
  const router = useRouter();
  const { t, locale } = useI18n();
  const [authenticated, setauthenticated] = useState(false);

  useEffect(() => {
    if (localStorage.getItem("UT_UI")) {
      setauthenticated(true);
    } else {
      router.push("/login");
    }
  }, [router]);
  if (!authenticated) {
    return (
      <div className="box-loading" style={{ minHeight: 600 }}>
        <span className="loader"></span>
      </div>
    );
  }
  return (
    <>
      <PageHead title="Customer Service" />
      <Box
        sx={{ bgcolor: "#F8F8F8" }}
        className="horizontal-safe-padding vertical-safe-padding"
      >
        <Box
          sx={{
            ...styles.box,
            width: { md: "530px" },
            m: "auto",
            py: { xs: 2, md: 4 },
          }}
        >
          <Typography
            variant="h2"
            sx={{ ...styles.title, mb: "16px", color: "#F18222" }}
          >
            {t.customer_services.title}
          </Typography>
          <Box>
            <Box
              component={Link}
              href="https://wa.me/20216177"
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "start",
                mb: { xs: 2, lg: 4 },
                textDecoration: "none",
              }}
            >
              <Box>
                <Box sx={{ display: "flex" }}>
                  <Box
                    component="img"
                    src="https://image-solution-no-scale.s3.us-east-2.amazonaws.com/upload/whatsapp-2.png"
                    alt="whatsapp chat"
                    width="24px"
                    height="24px"
                  />
                  <Typography
                    sx={{
                      ...styles.midHead,
                      mr: locale === "ar" ? "12px" : "0",
                      ml: locale !== "ar" ? "12px" : "0",
                    }}
                  >
                    {t.customer_services.whatsappCall.title}
                  </Typography>
                </Box>
                <Typography
                  sx={{
                    ...styles.smallHead,
                    color: "#6F7073",
                    marginTop: "6px",
                  }}
                >
                  {t.customer_services.whatsappCall.subTitle}
                </Typography>
              </Box>
              <Image
                quality={100}
                loading="lazy"
                src="https://image-solution-no-scale.s3.us-east-2.amazonaws.com/upload/next-arrow.png"
                alt="whatsapp-arrow"
                width="24px"
                height="24px"
                style={{
                  transform: locale === "en" ? "scaleX(-1)" : "scaleX(1)",
                }}
                objectFit="contain"
              />
            </Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mb: { xs: 2, lg: 4 },
              }}
            >
              <Box>
                <Box sx={{ display: "flex" }}>
                  <Image
                    quality={100}
                    loading="lazy"
                    src="https://image-solution-no-scale.s3.us-east-2.amazonaws.com/upload/call.png"
                    alt="call-icon"
                    width="24px"
                    height="24px"
                    objectFit="contain"
                  />
                  <Typography
                    sx={{
                      ...styles.midHead,
                      mr: locale === "ar" ? "12px" : "0",
                      ml: locale !== "ar" ? "12px" : "0",
                    }}
                  >
                    {t.customer_services.hotLineCall.title1}
                    <Link
                      href="tel:16177"
                      style={{
                        fontWeight: "bold",
                      }}
                    >
                      {t.customer_services.hotLineCall.title2}
                    </Link>
                  </Typography>
                </Box>
              </Box>

              <Typography
                component="a"
                href={`tel:${t.customer_services.hotLineCall.subTitle}`}
                sx={{
                  fontWeight: 800,
                  fontSize: { xs: "12px", md: "16px" },
                }}
              >
                {t.customer_services.hotLineCall.subTitle}
              </Typography>
            </Box>
            <Box
              component={Link}
              href="/our-branches"
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                textDecoration: "none",
              }}
              underline="none"
            >
              <Box>
                <Box sx={{ display: "flex" }}>
                  <Image
                    quality={100}
                    loading="lazy"
                    src="https://image-solution-no-scale.s3.us-east-2.amazonaws.com/upload/location.png"
                    alt="location-icon"
                    width="24px"
                    height="24px"
                    objectFit="contain"
                  />
                  <Typography
                    sx={{
                      ...styles.midHead,
                      mr: locale === "ar" ? "12px" : "0",
                      ml: locale !== "ar" ? "12px" : "0",
                    }}
                  >
                    {t.customer_services.ourLocation.title}
                  </Typography>
                </Box>
              </Box>
              <Image
                quality={100}
                loading="lazy"
                src="https://image-solution-no-scale.s3.us-east-2.amazonaws.com/upload/next-arrow.png"
                alt="location-arrow"
                width="24px"
                height="24px"
                style={{
                  transform: locale === "en" ? "scaleX(-1)" : "scaleX(1)",
                }}
                objectFit="contain"
              />
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  );
}
